export const localeSelector = (state) => state.i18n.locale
